import * as React from 'react';
import { IPaternList } from 'views/job-costing/utils/models';

interface IProps {
    data: IPaternList[],
    id: string,
	className?: string
}
export class PropertyDisplay extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props)
    }

    public render() {
        const dataList = this.props.data.map((el: IPaternList, index: number) => {
            return <div className={this.props.className || 'col-25'} key={`${this.props.id}-${index}`}>
                <label id={`${this.props.id}-${index}-label`} className="section-header-label">{el.label}</label>
                <label id={`${this.props.id}-${index}-value`} className="section-header-value">
                    {el.value}
                </label>
            </div>
        })
        return (
            <div className="grid-wrapper propertyDisplay" id={this.props.id}>
                {dataList}
            </div>
        );
    }
}

export default PropertyDisplay;